import { CanDeactivateFn } from '@angular/router';

export interface WorkOrderPanelHost {
  canLeaveWorkOrders(): Promise<boolean>;
}

export const workOrderPanelGuard: CanDeactivateFn<WorkOrderPanelHost> = (component) => {
  return component.canLeaveWorkOrders();
};
